import { Box, CircularProgress, Typography } from "@mui/material";

export default function PDFLoading({ progress }: { progress: number }) {
  return (
    <Box
      sx={{
        position: "absolute",
        backgroundColor: "#2d333e",
        display: "flex",
        height: "100%",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        inset: 0,
        gap: "1rem",
        zIndex: 1
      }}
    >
      <CircularProgress
        variant='determinate'
        value={progress}
        size={48}
        sx={{
          color: "primary.main",
          "& .MuiCircularProgress-circle": {
            strokeLinecap: "round"
          }
        }}
      />
      <Typography variant='body2' color='grey.100'>
        Loading PDF... {progress}%
      </Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
          opacity: 0.7
        }}
      >
        <Box
          sx={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            backgroundColor: "primary.main",
            animation: "pulse 1.5s linear infinite",
            "@keyframes pulse": {
              "0%": {
                transform: "scale(0.8)"
              },
              "50%": {
                transform: "scale(1.3)"
              },
              "100%": {
                transform: "scale(1)"
              }
            }
          }}
        />
        <Typography variant='caption' color='grey.100'>
          Streaming content
        </Typography>
      </Box>
    </Box>
  );
}
